import { createSelector } from "reselect";

export const getVal = (val) => val;
export const getValToArray = (val) => val.toArray();

export default function getSelectors(selectorsConfig) {
  const selectors = {};

  Object.keys(selectorsConfig).forEach((selectorKey) => {
    selectors[selectorKey] = createSelector(...selectorsConfig[selectorKey]);
  });

  return selectors;
}



// WEBPACK FOOTER //
// ./src/utils/getSelectors.js